/**
 * Auth0 `appState.returnTo` after interactive login from this app.
 * Students are moved to the student dashboard from `/#/app` via `index.jsx` + `useLoginRedirect`.
 */
export function getPostLoginReturnUrl() {
    return `${window.location.origin}/#/app`;
}
